import { Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import { useFormikContext } from 'formik';
import { PracticeEditResidence } from 'practice/view-models/practice-edit-residence';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';

interface FormProps {
  idFamilyAnpr?: string;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  intestatarioIsAnpr?: boolean;
  progressive?: string;
  typePractice?: string;
  ForPracticeTemporary?: boolean;
  disabled?: boolean;
  iniziativa?: string;
  fromPerson?: string;
}

const FormComponent = ({ ForPracticeTemporary, disabled }: FormProps): React.ReactElement => {
  const formContext = useFormikContext<PracticeEditResidence>();

  return (
    <Fragment>
      <Grid item container spacing={2}>
        <Grid item xs={12}>
          <Grid item xs={12} md={4}>
            <DatePicker
              label={ForPracticeTemporary ? 'Decorrenza' : 'Decorrenza *'}
              aria-label="Decorrenza"
              value={formContext.values?.effectiveDate || null}
              onChange={(date) => {
                formContext.setFieldValue('effectiveDate', date || null);
              }}
              disabled={formContext.values.isFromData || disabled}
              renderInput={(params) => (
                <PmiTextField
                  id="effectiveDate"
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.effectiveDate && Boolean(formContext.errors.effectiveDate)
                  }
                  helperText={formContext.errors.effectiveDate}
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

FormComponent.displayName = 'Accordion Residence - form';

const Form = memo(FormComponent);

export default Form;
